import { render, staticRenderFns } from "./ActSelector.vue?vue&type=template&id=47894778"
import script from "./ActSelector.vue?vue&type=script&lang=js"
export * from "./ActSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports